import React, { useEffect, useRef, useState } from "react";
import SearchSelect from "./SearchSelect";
import PhoneInput from "react-phone-number-input";
import TextField from "@mui/material/TextField";
import "./form.scss";
import FormControl from "@mui/material/FormControl";
import { MenuItem } from "@mui/material";
import { withTranslation, useTranslation } from "react-i18next";
import dateFormat from "dateformat";
import { Button } from "antd";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import NativeSelect from "@mui/material/NativeSelect";
import { useSelector } from "react-redux";
import { SectionHead, ChooseFrom, uniqueByName } from "./FormSection";

const CustomDisableInput = styled(TextField)(() => ({
  ".MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#000",
    color: "#000",
  },

  ".MuiInputLabel-formControl.Mui-disabled": {
    WebkitTextFillColor: "#000",
    color: "#000",
  },
}));

function AddForm(props) {
  const [rnd0, setRnd0] = useState();
  const [rnd, setRnd] = useState();
  const [rnd1, setRnd1] = useState();
  const [rnd2, setRnd2] = useState();
  const [rnd3, setRnd3] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [checkstate0, setCheckstate0] = useState(true);
  const [checkstate, setCheckstate] = useState(true);
  const [checkstate1, setCheckstate1] = useState(true);
  const [checkstate2, setCheckstate2] = useState(true);
  const [checkstate3, setCheckstate3] = useState(true);
  const [rid, setRid] = useState();
  const [rhid, setRHid] = useState();
  const [did, setDid] = useState();
  const [pid, setPid] = useState();
  const [mid, setMid] = useState();
  const user = useSelector((state) => state.profile?.data[0]);
  const [rname, setRname] = useState();
  const [radress, setRadress] = useState();
  const [rfax, setRfax] = useState();
  const [rphone, setRphone] = useState();
  const [dname, setDname] = useState();
  const [trade_name, settrade_name] = useState();
  const [structure, setstructure] = useState();
  const [drug_figure, setdrug_figure] = useState();
  const [drug_type, setDrug_type] = useState();
  const [drugTypes, setDrugTypes] = useState();
  const [usage, setusage] = useState();
  const [patent, setpatent] = useState();
  const [pname, setPname] = useState();
  const [padress, setPadress] = useState();
  const [pfax, setPfax] = useState();
  const [pphone, setPphone] = useState();
  const [mname, setMname] = useState();
  const [madress, setMadress] = useState();
  const [mfax, setMfax] = useState();
  const [mphone, setMphone] = useState();
  const [err, setErr] = useState();
  const [rdata, setRdata] = useState([]);
  const [rhdata, setRHdata] = useState([]);
  const [right_holder, setRightHolder] = useState();
  const [rhname, setRHname] = useState();
  const [rhadress, setRHadress] = useState();
  const [rhcountryid, setRHcountryid] = useState();
  const [rhfax, setRHfax] = useState();
  const [rhphone, setRHphone] = useState();
  const [ddata, setDdata] = useState([]);
  const [pdata, setPdata] = useState([]);
  const [mdata, setMdata] = useState([]);
  const [drugd, setDrugd] = useState([]);
  const [repd, setrepd] = useState([]);
  const [rhepd, setrhepd] = useState([]);
  const [drugb, setDrugb] = useState(false);
  const [repb, setrepb] = useState(false);
  const [rhepb, setrhepb] = useState(false);
  const [prepd, setprepd] = useState([]);
  const [prepb, setprepb] = useState(false);
  const [mand, setmand] = useState([]);
  const [manb, setmanb] = useState(false);
  const [country, setCountry] = useState();
  const [drugfig, setDrugFig] = useState();
  const [certificate, setSertificate] = useState();
  const [dublicate, setDublicate] = useState(false);
  const [certificate_number, setCertificateNumber] = useState();
  const refdrug = useRef(null);
  const onChange0 = (e) => {
    setRnd0(Math.random());
    setCheckstate0(!checkstate0);
    // if (checkstate0) {
    //   setCheckstate0(false);
    // } else setCheckstate0(true);
    setRHid();
    setRHname();
    setrhepb(!rhepb);

    for (var member in rhepd) delete rhepd[member];
  };
  const onChange = (e) => {
    setRnd(Math.random());
    if (checkstate) {
      setCheckstate(false);
    } else setCheckstate(true);
    setRid();
    setRname();
    setrepb(!repb);

    for (var member in repd) delete repd[member];
  };
  const onChangeDublicate = (e) => {
    setDublicate(!dublicate);
  }
  const onChange1 = (e) => {
    setRnd1(Math.random());
    if (checkstate1) {
      setCheckstate2(true);
      setCheckstate3(true);
      setCheckstate1(false);
      setDrugb(true);
      setmanb(true);
      setprepb(true);
      delete drugd["preparer"];
      for (var member in prepd) delete prepd[member];
      delete drugd["manufacturer"];
      for (var member in mand) delete mand[member];
    } else {
      setCheckstate1(true);
      setprepb(false);
      setDrugb(false);
      setmanb(false);
      setMphone();
      setPphone();
    }
    setErr();
    setDid();
    setDname();
    for (var member in drugd) delete drugd[member];
  };
  const onChange2 = (e) => {
    setRnd2(Math.random());
    if (checkstate2) {
      setCheckstate2(false);
    } else setCheckstate2(true);
    setPid();
    setPname();
    setprepb(!prepb);
    setPphone();
    delete drugd["preparer"];
    for (var member in prepd) delete prepd[member];

    setErr();
  };
  const onChange3 = (e) => {
    setRnd3(Math.random());
    if (checkstate3) {
      setCheckstate3(false);
    } else {
      setCheckstate3(true);
      setMid();
      setMphone();
    }
    setErr();

    setMname();
    setmanb(!manb);
    delete drugd["manufacturer"];
    for (var member in mand) delete mand[member];
  };
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  useEffect(() => {
    axios.get(url.url + "/certificates/list", { headers: headers() }).then((res) => {
      setSertificate(res.data.data);
    });
    axios.get(url.url + "/drug/figure", { headers: headers() }).then((res) => {
      setDrugFig(res.data.data);
    });
    axios.get(url.url + "/drug-type", { headers: headers() }).then((res) => {
      setDrugTypes(res.data.data);
    });
    axios
      .get(url.url + "/entity?type=representative", { headers: headers() })
      .then((res) => {
        setRdata(uniqueByName(res.data.data));
      });
    axios
      .get(url.url + "/entity?type=rightholder", { headers: headers() })
      .then((res) => {
        setRHdata(uniqueByName(res.data.data));
      });
    axios
      .get(url.url + "/entity?type=preparer", { headers: headers() })
      .then((res) => {
        setPdata(uniqueByName(res.data.data));
      });
    axios
      .get(url.url + "/entity?type=manufacturer", { headers: headers() })
      .then((res) => {
        setMdata(uniqueByName(res.data.data));
      });
    axios.get(url.url + "/drug", { headers: headers() }).then((res) => {
      setDdata(uniqueByName(res.data.data));
    });
    axios
      .get(url.url + "/country", { headers: headers() })
      .then((res) => {
        setCountry(res.data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
        toast.error(err.response.data);
      });
  }, []);
  useEffect(() => {
    if (did) {
      axios
        .get(url.url + `/drug/${did}`, { headers: headers() })
        .then((res) => {
          setDrugd(res.data.data);
          setMphone(res.data.data.manufacturer.phone);
          setPphone(res.data.data.preparer.phone);
        });
      setDrugb(true);
    }
  }, [did]);
  useEffect(() => {
    if (rid) {
      axios
        .get(url.url + `/entity/${rid}`, { headers: headers() })
        .then((res) => {
          setrepd(res.data.data);
        });
      setrepb(true);
    }
  }, [rid]);
  useEffect(() => {
    if (rhid) {
      axios
        .get(url.url + `/entity/${rhid}`, { headers: headers() })
        .then((res) => {
          setrhepd(res.data.data);
        });
      setrepb(true);
    }
  }, [rhid]);
  useEffect(() => {
    if (pid) {
      axios
        .get(url.url + `/entity/${pid}`, { headers: headers() })
        .then((res) => {
          setprepd(res.data.data);
          setPphone(res.data.data.phone);
        });
      setprepb(true);
    }
  }, [pid]);
  useEffect(() => {
    if (mid) {
      axios
        .get(url.url + `/entity/${mid}`, { headers: headers() })
        .then((res) => {
          setmand(res.data.data);
          setMphone(res.data.data.phone);
        });
      setmanb(true);
    }
  }, [mid]);
  const handleSave = () => {
    // Dori turi tanlanmasa so'rov yubormaymiz (eski arizalarda 0 bo'lishi mumkin)
    if (!drugTypes?.some((o) => o.id == drug_type)) {
      const message = t("Select_drug_type");
      setErr((prev) => ({ ...(prev || {}), drug_type_id: [message] }));
      toast.error(message);
      document
        .getElementById("drug_type_select")
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    const data = {
      applicant: user?.data.legal_entity?.name,
      drug_type_id: drug_type,
      is_dublicate: dublicate ? true : false,
      parrent_certificate_number: document.getElementById("certificate_number")?.value,
    };
    if (rid) {
      data.representative_id = rid;
    } else {
      data.representative = {
        name: rname,
        address: radress,
        fax: rfax,
        phone: rphone,
      };
    }
    if (rhid) {
      data.right_holder_id = rhid;
    } else {
      data.right_holder = {
        country_id: document.getElementById("right_holder_country").value,
        name: rhname,
        address: rhadress,
        fax: rhfax,
        phone: rhphone,
      };
    }
    if (did) {
      data.drug_id = did;
    } else {
      data.drug = {
        name: dname,
        trade_name: trade_name,
        structure: structure,
        drug_figure_id: document.getElementById("examplefigure").value,
        usage: usage,
        patent: patent,
        country_id: document.getElementById("examplecountry").value,
      };
      if (pid) {
        data.drug.preparer_id = pid;
      } else {
        data.drug.preparer = {
          name: pname,
          address: padress,
          fax: pfax,
          phone: pphone,
          country_id: document.getElementById("preparer_country")?.value || null,
        };
      }
      if (mid) {
        data.drug.manufacturer_id = mid;
      } else {
        data.drug.manufacturer = {
          name: mname,
          address: madress,
          fax: mfax,
          phone: mphone,
          country_id: document.getElementById("manufacturer_country")?.value || null,
        };
      }
    }

    axios
      .post(url.url + "/application", data, { headers: headers() })
      .then((res) => {
        localStorage.setItem("applic", res.data.data.id);
        if (res.status == 201) {
          setErr();
          toast.success(t("Success!"));
          props.handlenext(res.data.data.id);
        }
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
        setErr(err.response.data.errors);
      });
  };
  if (user)
    return (
      <div className="af">
        <div className="af-row">
        <section className="af-card">
              <SectionHead index={1} title={t("Rights Holder Information")}>
                <ChooseFrom onChange={onChange0} />
              </SectionHead>
              <div key={rnd0} className="af-grid">
                {checkstate0 ? (
                  err?.["right_holder.name"] ? (
                    <CustomDisableInput
                      error
                      helperText={err?.["right_holder.name"]}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Right Holder")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRHname(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Right Holder")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRHname(e.target.value)}
                    />
                  )
                ) : (
                  <CustomDisableInput
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    select
                    label={t("Right Holder")}
                    helperText=""
                    variant="standard"
                    onChange={(e) => setRHid(e.target.value)}
                    defaultValue={rhdata[0]?.name}
                  >
                    {rhdata?.map((option, i) => (
                      <MenuItem
                        key={i}
                        value={option.id}
                        sx={{
                          "&.MuiButtonBase-root:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        style={{ backgroundColor: "transparent" }}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </CustomDisableInput>
                )}
                {err?.["right_holder.country_id"] ? (
                  <div>
                    <span
                      className="titleee"
                      style={drugb ? { color: "#000" } : {}}
                    >
                      {t("Country")}
                    </span>
                    <FormControl
                      defaultValue={rhepd?.country_id}
                      fullWidth
                      className="appp-inp text-field mb-2 mt-2"
                    >
                      <SearchSelect
                        id="right_holder_country"
                        options={country?.data}
                        placeholder={t("ln_country_search")}
                        defaultValue={rhepd?.country_id}
                      />
                    </FormControl>
                  </div>
                ) : (
                  <div>
                    <span
                      className="titleee"
                      style={drugb ? { color: "#000" } : {}}
                    >
                      {t("Country")}
                    </span>
                    <FormControl
                      defaultValue={rhepd?.country_id}
                      fullWidth
                      className="appp-inp text-field mb-2 mt-2"
                    >
                      <SearchSelect
                        id="right_holder_country"
                        options={country?.data}
                        placeholder={t("ln_country_search")}
                        defaultValue={rhepd?.country_id}
                      />
                    </FormControl>
                  </div>
                )
                }

                {err?.["right_holder.address"] ? (
                  <CustomDisableInput
                    error
                    helperText={err?.["right_holder.address"]}
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Address")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setRHadress(e.target.value)}
                  />
                ) : (
                  <div key={rhepd?.address + "rhepd-Address"}>
                    <CustomDisableInput
                      disabled={rhepb}
                      defaultValue={rhepd?.address}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRHadress(e.target.value)}
                    />
                  </div>
                )}
                {err?.["right_holder.fax"] ? (
                  <CustomDisableInput
                    error
                    helperText={err?.["right_holder.fax"]}
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Fax address")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setRHfax(e.target.value)}
                  />
                ) : (
                  <div key={rhepd?.fax + "rhepd-Fax address"}>
                    <CustomDisableInput
                      disabled={rhepb}
                      defaultValue={rhepd?.fax}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Fax address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRHfax(e.target.value)}
                    />
                  </div>
                )}

                <div key={rhepd?.phone + "Phone number"}>
                  <span
                    className="titleee"
                    style={drugb ? { color: "#000" } : {}}
                  >
                    {t("Phone number")}
                  </span>
                  <PhoneInput
                    disabled={rhepb}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    className={
                      err?.["right_holder.phone"]
                        ? "inpp-countryy err-phone"
                        : "inpp-countryy"
                    }
                    international
                    defaultCountry="UZ"
                    value={rhepd?.phone}
                    onChange={(e) => setRphone(e)}
                  />
                  {err?.["right_holder.phone"] ? (
                    <div className="invalid-phone">
                      {err?.["right_holder.phone"]}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
        </section>
        <section className="af-card">
              <SectionHead index={2} title={t("Applicant_Information")}>
                <ChooseFrom onChange={onChange} />
              </SectionHead>
              {/* <div className="check-lable">
                <Switch defaultChecked={false} onChange={onChangeDublicate} />
                <span> {t("dublicate")} </span>
                <Tooltip
                  className="ml-2"
                  placement="right"
                  title={t("Dublikat uchun ariza topshirishda guvohnoma tanlang!")}
                  color={"#109cf1"}
                >
                  <InfoCircleOutlined className="icon-inf" />
                </Tooltip>
              </div> */}
              {/* {
                dublicate ? (
                  // err?.["parrent_certificate_number"] ? (
                  //   <div >
                  //     {err?.["parrent_certificate_number"]}
                  //     <span
                  //       className="titleee"
                  //       style={dublicate ? { color: "#000" } : {}}
                  //     >
                  //       {t("Dublikat uchun guvohnoma")}
                  //     </span>

                  //     <FormControl
                  //       disabled={!dublicate}
                  //       fullWidth
                  //       className="appp-inp text-field mb-2 mt-2"
                  //       helperText={err?.["parrent_certificate_number"]}
                  //     >
                  //       <NativeSelect
                  //         helperText={err?.["parrent_certificate_number"]}
                  //         style={certificate ? { color: "#000" } : {}}
                  //         inputProps={{
                  //           id: "certificate_number",
                  //         }}

                  //       >
                  //         <option value=""></option>
                  //         {certificate?.map((res, i) => (
                  //           <option key={i} value={res.number}>
                  //             № {res.number}
                  //           </option>
                  //         ))}
                  //       </NativeSelect>
                  //     </FormControl>
                  //   </div>
                  // ) : (

                  //   <div >
                  //     <span
                  //       className="titleee"
                  //       style={dublicate ? { color: "#000" } : {}}
                  //     >
                  //       {t("Dublikat uchun guvohnoma")}
                  //     </span>

                  //     <FormControl
                  //       disabled={!dublicate}
                  //       fullWidth
                  //       className="appp-inp text-field mb-2 mt-2"

                  //     >
                  //       <NativeSelect
                  //         style={certificate ? { color: "#000" } : {}}

                  //         inputProps={{
                  //           id: "certificate_number",
                  //         }}

                  //       >
                  //         <option value=""></option>
                  //         {certificate?.map((res, i) => (
                  //           <option key={i} value={res.number}>
                  //             № {res.number}
                  //           </option>
                  //         ))}
                  //       </NativeSelect>
                  //     </FormControl>
                  //   </div>
                  // )
                  err?.["parrent_certificate_number"] ? (
                    <CustomDisableInput
                      error
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      select
                      label={t("Dublikat uchun guvohnoma")}
                      onChange={(e) => setCertificateNumber(e.target.value)}
                      helperText={err?.["parrent_certificate_number"]}
                      variant="standard"
                    >
                      {certificate?.map((option, i) => (

                        <MenuItem
                          key={i}
                          value={option.number}
                          sx={{
                            "&.MuiButtonBase-root:hover": {
                              backgroundColor: "red",
                            },
                          }}
                          style={{ backgroundColor: "transparent" }}
                        >
                          № {option.number}
                        </MenuItem>
                      ))}
                    </CustomDisableInput>
                  ) : (
                    <CustomDisableInput
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      select
                      label={t("Dublikat uchun guvohnoma")}
                      onChange={(e) => setCertificateNumber(e.target.value)}
                      helperText=""
                      variant="standard"
                    >
                      {certificate?.map((option, i) => (
                        <MenuItem
                          key={i}
                          value={option.number}
                          sx={{
                            "&.MuiButtonBase-root:hover": {
                              backgroundColor: "red",
                            },
                          }}
                          style={{ backgroundColor: "transparent" }}
                        >
                          № {option.number}
                        </MenuItem>
                      ))}
                    </CustomDisableInput>
                  )

                ) : null
              } */}
              <CustomDisableInput
                disabled
                defaultValue={user?.data.legal_entity?.name}
                className="appp-inp text-field mb-2 mt-2"
                fullWidth
                label={t("Applicant")}
                variant="standard"
                type="text"
              />
              <div key={rnd} className="af-grid">
                {checkstate ? (
                  err?.["representative.name"] ? (
                    <CustomDisableInput
                      error
                      helperText={err?.["representative.name"]}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Representative of the applicant")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRname(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Representative of the applicant")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRname(e.target.value)}
                    />
                  )
                ) : (
                  <CustomDisableInput
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    select
                    label={t("Representative of the applicant")}
                    helperText=""
                    variant="standard"
                    onChange={(e) => setRid(e.target.value)}
                    defaultValue={rdata[0]?.name}
                  >
                    {rdata?.map((option, i) => (
                      <MenuItem
                        key={i}
                        value={option.id}
                        sx={{
                          "&.MuiButtonBase-root:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        style={{ backgroundColor: "transparent" }}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </CustomDisableInput>
                )}
                {err?.["representative.address"] ? (
                  <CustomDisableInput
                    error
                    helperText={err?.["representative.address"]}
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Address")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setRadress(e.target.value)}
                  />
                ) : (
                  <div key={repd?.address + "repd-Address"}>
                    <CustomDisableInput
                      disabled={repb}
                      defaultValue={repd?.address}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRadress(e.target.value)}
                    />
                  </div>
                )}
                {err?.["representative.fax"] ? (
                  <CustomDisableInput
                    error
                    helperText={err?.["representative.fax"]}
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Fax address")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setRfax(e.target.value)}
                  />
                ) : (
                  <div key={repd?.fax + "repd-Fax address"}>
                    <CustomDisableInput
                      disabled={repb}
                      defaultValue={repd?.fax}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Fax address")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRfax(e.target.value)}
                    />
                  </div>
                )}

                <div key={repd?.phone + "Phone number"}>
                  {/* <CustomDisableInput
                      disabled={repb}
                      defaultValue={repd?.phone}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Phone number")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setRphone(e.target.value)}
                    /> */}
                  <span
                    className="titleee"
                    style={drugb ? { color: "#000" } : {}}
                  >
                    {t("Phone number")}
                  </span>
                  <PhoneInput
                    disabled={repb}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    className={
                      err?.["representative.phone"]
                        ? "inpp-countryy err-phone"
                        : "inpp-countryy"
                    }
                    international
                    defaultCountry="UZ"
                    value={repd?.phone}
                    onChange={(e) => setRphone(e)}
                  />
                  {err?.["representative.phone"] ? (
                    <div className="invalid-phone">
                      {err?.["representative.phone"]}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
        </section>
        </div>
        <section className="af-card">
              <SectionHead index={3} title={t("Drug Information")}>
                <ChooseFrom onChange={onChange1} />
              </SectionHead>
              <CustomDisableInput
                id="drug_type_select"
                error={!!err?.["drug_type_id"]}
                value={drugTypes?.some((o) => o.id == drug_type) ? drug_type : ""}
                className="appp-inp text-field mb-2 mt-2"
                fullWidth
                select
                required
                label={t("Drug_type")}
                onChange={(e) => {
                  setDrug_type(e.target.value);
                  setErr((prev) => (prev ? { ...prev, drug_type_id: undefined } : prev));
                }}
                helperText={err?.["drug_type_id"] || ""}
                variant="standard"
              >
                {drugTypes?.map((option, i) => (
                  <MenuItem
                    key={i}
                    value={option.id}
                    sx={{
                      "&.MuiButtonBase-root:hover": {
                        backgroundColor: "red",
                      },
                    }}
                    style={{ backgroundColor: "transparent" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </CustomDisableInput>
              <div key={rnd1} className="af-grid af-grid--3">
                {checkstate1 ? (
                  err?.["drug.name"] ? (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.name"]}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Drug")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setDname(e.target.value)}
                    />
                  ) : (
                    <CustomDisableInput
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Drug")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setDname(e.target.value)}
                    />
                  )
                ) : (
                  <CustomDisableInput
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    select
                    label={t("Drug")}
                    onChange={(e) => setDid(e.target.value)}
                    helperText=""
                    variant="standard"
                    defaultValue={ddata[0]?.name}
                  >
                    {ddata?.map((option, i) => (
                      <MenuItem
                        key={i}
                        value={option.id}
                        sx={{
                          "&.MuiButtonBase-root:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        style={{ backgroundColor: "transparent" }}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </CustomDisableInput>
                )}
                {err?.["drug.trade_name"] ? (
                  <CustomDisableInput
                    className="appp-inp text-field mb-2 mt-2"
                    error
                    helperText={err?.["drug.trade_name"]}
                    fullWidth
                    label={t("Trade name")}
                    variant="standard"
                    type="text"
                    onChange={(e) => settrade_name(e.target.value)}
                  />
                ) : (
                  <div key={drugd?.trade_name}>
                    <CustomDisableInput
                      disabled={drugb}
                      defaultValue={drugd?.trade_name}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Trade name")}
                      variant="standard"
                      type="text"
                      onChange={(e) => settrade_name(e.target.value)}
                    />
                  </div>
                )}
                {err?.["drug.structure"] ? (
                  <CustomDisableInput
                    error
                    helperText={err?.["drug.structure"]}
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Content")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setstructure(e.target.value)}
                  />
                ) : (
                  <div key={drugd?.structure + "Content"}>
                    <CustomDisableInput
                      disabled={drugb}
                      defaultValue={drugd?.structure}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Content")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setstructure(e.target.value)}
                    />
                  </div>
                )}

                <div key={drugd?.drug_figure + "Drug form"}>
                  <span
                    className="titleee"
                    style={drugb ? { color: "#000" } : {}}
                  >
                    {t("Drug form")}
                  </span>
                  <FormControl
                    disabled={drugb}
                    fullWidth
                    className="appp-inp text-field mb-2 mt-2"
                  >
                    <SearchSelect
                      id="examplefigure"
                      options={drugfig}
                      defaultValue={`${drugd?.drug_figure?.id}`}
                      allowEmpty
                    />
                  </FormControl>
                </div>
                {err?.["drug.usage"] ? (
                  <CustomDisableInput
                    error
                    helperText={err?.["drug.usage"]}
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Applicat")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setusage(e.target.value)}
                  />
                ) : (
                  <div key={drugd?.usage + "Applicat"}>
                    <CustomDisableInput
                      ref={refdrug}
                      disabled={drugb}
                      defaultValue={drugd?.usage}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Applicat")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setusage(e.target.value)}
                    />
                  </div>
                )}
                {err?.["drug.patent"] ? (
                  <CustomDisableInput
                    error
                    helperText={err?.["drug.patent"]}
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Patent")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setpatent(e.target.value)}
                  />
                ) : (
                  <div key={drugd?.patent + "Patent"}>
                    <CustomDisableInput
                      disabled={drugb}
                      defaultValue={drugd?.patent}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Patent")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setpatent(e.target.value)}
                    />
                  </div>
                )}
                <div>
                  <span
                    className="titleee"
                    style={drugb ? { color: "#000" } : {}}
                  >
                    {t("Country")}
                  </span>
                  <FormControl
                    disabled={drugb}
                    fullWidth
                    className="appp-inp text-field mb-2 mt-2"
                  >
                    <SearchSelect
                      id="examplecountry"
                      options={country?.data}
                        placeholder={t("ln_country_search")}
                      defaultValue={drugd?.country?.id}
                    />
                  </FormControl>
                </div>
              </div>
        </section>
        <div className="af-row">
        <section className="af-card">
              <SectionHead index={4} title={t("Preparer")}>
                {checkstate1 ? (
                  <ChooseFrom disabled={drugb} onChange={onChange2} />
                ) : null}
              </SectionHead>
              <div key={rnd2} className="af-grid">
                {checkstate2 ? (
                  err?.["drug.preparer.name"] ? (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.preparer.name"]}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Preparer")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setPname(e.target.value)}
                    />
                  ) : (
                    <div
                      key={
                        drugd.preparer
                          ? drugd.preparer?.name + "Preparer"
                          : prepd?.name + "Preparer"
                      }
                    >
                      <CustomDisableInput
                        disabled={drugd.preparer ? drugb : prepb}
                        defaultValue={
                          drugd.preparer ? drugd.preparer?.name : prepd?.name
                        }
                        className="appp-inp text-field mb-2 mt-2"
                        fullWidth
                        label={t("Preparer")}
                        variant="standard"
                        type="text"
                        onChange={(e) => setPname(e.target.value)}
                      />
                    </div>
                  )
                ) : (
                  <CustomDisableInput
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    select
                    label={t("Preparer")}
                    onChange={(e) => setPid(e.target.value)}
                    helperText=""
                    variant="standard"
                    defaultValue={pdata[0]?.name}
                  >
                    {pdata?.map((option, i) => (
                      <MenuItem
                        key={i}
                        value={option.id}
                        sx={{
                          "&.MuiButtonBase-root:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        style={{ backgroundColor: "transparent" }}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </CustomDisableInput>
                )}
                <div
                  key={
                    drugd.preparer
                      ? drugd.preparer?.address + "preparerAddress"
                      : prepd?.address + "preparerAddress"
                  }
                >
                  <CustomDisableInput
                    disabled={drugd.preparer ? drugb : prepb}
                    defaultValue={
                      drugd.preparer ? drugd.preparer?.address : prepd?.address
                    }
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Address")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setPadress(e.target.value)}
                  />
                </div>
                <div
                  key={
                    drugd.preparer
                      ? drugd.preparer?.fax + "preparerFax address"
                      : prepd?.fax + "preparerFax address"
                  }
                >
                  <CustomDisableInput
                    disabled={drugd.preparer ? drugb : prepb}
                    defaultValue={
                      drugd.preparer ? drugd.preparer?.fax : prepd?.fax
                    }
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Fax address")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setPfax(e.target.value)}
                  />
                </div>
                <div
                  key={
                    drugd.preparer
                      ? drugd.preparer?.phone + "preparerPhone number"
                      : prepd?.phone + "preparerPhone number"
                  }
                >
                  <span
                    className="titleee"
                    style={drugb ? { color: "#000" } : {}}
                  >
                    {t("Phone number")}
                  </span>
                  <PhoneInput
                    disabled={drugd.preparer ? drugb : prepb}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    className={
                      err?.["drug.preparer.phone"]
                        ? "inpp-countryy err-phone"
                        : "inpp-countryy"
                    }
                    international
                    defaultCountry="UZ"
                    value={pphone}
                    onChange={(e) => setPphone(e)}
                  />
                  {err?.["drug.preparer.phone"] ? (
                    <div className="invalid-phone">
                      {err?.["drug.preparer.phone"]}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  key={
                    (drugd.preparer ? drugd.preparer?.country_id : prepd?.country_id) + "preparerCountry"
                  }
                >
                  <span className="titleee">{t("Country")}</span>
                  <FormControl
                    disabled={drugd.preparer ? drugb : prepb}
                    fullWidth
                    className="appp-inp text-field mb-2 mt-2"
                  >
                    <SearchSelect
                      id="preparer_country"
                      options={country?.data}
                        placeholder={t("ln_country_search")}
                      defaultValue={(drugd.preparer ? drugd.preparer?.country_id : prepd?.country_id) || ""}
                      allowEmpty
                    />
                  </FormControl>
                  {err?.["drug.preparer.country_id"] ? (
                    <div className="invalid-phone">{err?.["drug.preparer.country_id"]}</div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
        </section>
        <section className="af-card">
              <SectionHead index={5} title={t("Manufacturer")}>
                {checkstate1 ? (
                  <ChooseFrom disabled={drugb} onChange={onChange3} />
                ) : null}
              </SectionHead>
              <div key={rnd3} className="af-grid">
                {checkstate3 ? (
                  err?.["drug.manufacturer.name"] ? (
                    <CustomDisableInput
                      error
                      helperText={err?.["drug.manufacturer.name"]}
                      className="appp-inp text-field mb-2 mt-2"
                      fullWidth
                      label={t("Manufacturer")}
                      variant="standard"
                      type="text"
                      onChange={(e) => setMname(e.target.value)}
                    />
                  ) : (
                    <div
                      key={
                        drugd.manufacturer
                          ? drugd.manufacturer?.name + "Manufacturer"
                          : mand?.name + "Manufacturer"
                      }
                    >
                      <CustomDisableInput
                        disabled={drugd.manufacturer ? drugb : manb}
                        defaultValue={
                          drugd.manufacturer
                            ? drugd.manufacturer?.name
                            : mand?.name
                        }
                        className="appp-inp text-field mb-2 mt-2"
                        fullWidth
                        label={t("Manufacturer")}
                        variant="standard"
                        type="text"
                        onChange={(e) => setMname(e.target.value)}
                      />
                    </div>
                  )
                ) : (
                  <CustomDisableInput
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    select
                    label={t("Manufacturer")}
                    onChange={(e) => setMid(e.target.value)}
                    helperText=""
                    variant="standard"
                    defaultValue={mdata[1]?.name}
                  >
                    {mdata?.map((option, i) => (
                      <MenuItem
                        key={i}
                        value={option.id}
                        sx={{
                          "&.MuiButtonBase-root:hover": {
                            backgroundColor: "red",
                          },
                        }}
                        style={{ backgroundColor: "transparent" }}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </CustomDisableInput>
                )}
                <div
                  key={
                    drugd?.manufacturer
                      ? drugd?.manufacturer?.address + "Address"
                      : mand?.address + "Address"
                  }
                >
                  <CustomDisableInput
                    disabled={drugd.manufacturer ? drugb : manb}
                    defaultValue={
                      drugd.manufacturer
                        ? drugd.manufacturer?.address
                        : mand?.address
                    }
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Address")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setMadress(e.target.value)}
                  />
                </div>
                <div
                  key={
                    drugd.manufacturer
                      ? drugd.manufacturer?.fax + "Fax address"
                      : mand?.fax + "Fax address"
                  }
                >
                  <CustomDisableInput
                    disabled={drugd.manufacturer ? drugb : manb}
                    defaultValue={
                      drugd.manufacturer ? drugd.manufacturer?.fax : mand?.fax
                    }
                    className="appp-inp text-field mb-2 mt-2"
                    fullWidth
                    label={t("Fax address")}
                    variant="standard"
                    type="text"
                    onChange={(e) => setMfax(e.target.value)}
                  />
                </div>

                <div>
                  <span
                    className="titleee"
                    style={drugb ? { color: "#000" } : {}}
                  >
                    {t("Phone number")}
                  </span>
                  <PhoneInput
                    disabled={drugd.manufacturer ? drugb : manb}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    className={
                      err?.["drug.manufacturer.phone"]
                        ? "inpp-countryy err-phone"
                        : "inpp-countryy"
                    }
                    international
                    defaultCountry="UZ"
                    value={mphone}
                    onChange={(e) => setMphone(e)}
                  />
                  {err?.["drug.manufacturer.phone"] ? (
                    <div className="invalid-phone">
                      {err?.["drug.manufacturer.phone"]}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  key={
                    (drugd.manufacturer ? drugd.manufacturer?.country_id : mand?.country_id) + "manufacturerCountry"
                  }
                >
                  <span className="titleee">{t("Country")}</span>
                  <FormControl
                    disabled={drugd.manufacturer ? drugb : manb}
                    fullWidth
                    className="appp-inp text-field mb-2 mt-2"
                  >
                    <SearchSelect
                      id="manufacturer_country"
                      options={country?.data}
                        placeholder={t("ln_country_search")}
                      defaultValue={(drugd.manufacturer ? drugd.manufacturer?.country_id : mand?.country_id) || ""}
                      allowEmpty
                    />
                  </FormControl>
                  {err?.["drug.manufacturer.country_id"] ? (
                    <div className="invalid-phone">{err?.["drug.manufacturer.country_id"]}</div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
        </section>
        </div>

        <div className="af-actions">
          <div className="af-actions__date">
            <i className="bx bx-calendar"></i>
            <span>{dateFormat(new Date(), "dd.mm.yyyy")}</span>
          </div>
          <div className="af-actions__buttons">
            <Button
              size="large"
              onClick={() => navigate("/account/applications")}
            >
              {t("Cancel")}
            </Button>
            <Button type="primary" size="large" onClick={handleSave}>
              {t("Save")}
            </Button>
          </div>
        </div>
      </div>
    );
}

export default withTranslation()(AddForm);
